<script>
import lazyLoadComponent from '@router/lazyload-component'
import { genderFilter, orderStatusMap } from '@utils/filter-value-to-text'
import { messageStore, messageDelete } from '@utils/message'
import formatDate from '@utils/format-date'
import { cloneDeep } from 'lodash'

export default {
  components: {
    ImageUpload: () => lazyLoadComponent(import('@components/ImageUpload')),
  },
  filters: {
    formatDate,
    genderFilter,
  },
  props: {
    pet: {
      type: Number,
      default: null,
    },
    order: {
      type: Object,
      default: () => { },
    },
    type: {
      type: String,
      default: '',
    },
    classStyle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // afterOrder,
      // handle,
      commentList: [],
      submitData: {
        images: [],
        content: '',
        uuid: '',
        questions: {
          afterOrderOption: [null, null, null, null, []],
          afterOrder: [],
          handle: [],
        },
      },
      defaultValue: {
        images: [],
        content: '',
        uuid: '',
        questions: {
          afterOrderOption: [null, null, null, null, []],
          afterOrder: [],
          handle: [],
        },
      },
      mode: 'new',
      shareLink: '',
      commentId: '',
      fileList: [],
      drawerVisible: false,
      dialogSendVisible: false,
      dialogImgVisible: false,
      tryingFetchList: false,
      tryingSave: false,
      tryingRemove: false,
      tryToGetLink: false,
      dialogImageUrl: '',
      listOrderId: '',
      appStyle: process.env.VUE_APP_BUILD_MODE === 'admin-app-build',
    }
  },
  computed: {
    dingBeautyNotShow() {
      if (window.globalData.APP_TYPE === 'dingbeauty') {
        return false
      }
      return true
    },
    orderId() {
      return this.order?.id || undefined
    },
    submitRules() {
      // const noImages = this.fileList.length===0
      return {
        content: [
          {
            required: this.fileList.length === 0 && !this.submitData.questions.afterOrder.length,
            message: '請填寫備註或美容狀況或上傳圖片',
            // trigger: 'blur',
          },
        ],
      }
    },
    currentUserGroupIds() {
      return this.$store.state.auth.currentUser.groups
    },
    hasPermission() {
      return this.currentUserGroupIds.includes(7) || this.currentUserGroupIds.includes(8)
    },
    userId() {
      return this.$store.state.auth.currentUser.id
    },
  },
  watch: {
    'pet': {
      handler(val, oldVal) {
        if (val !== oldVal) {
          this.tryToFetchList()
        }
      },
    }
  },
  created() {
    this.tryToFetchList()
  },
  mounted() {
  },
  methods: {
    afterOrder(questions) {
      let string = []
      questions.afterOrder.forEach((item) => {
        if (item === '正常') {
          string.push('正常')
        }
        if (item === '皮膚病') {
          string.push('皮膚病')
        }
        if (item === '指甲流血') {
          string.push('指甲流血')
        }
        if (item === '剃傷') {
          string.push('剃傷')
        }
        if (item === '跳蚤') {
          let text = ''
          if (questions.afterOrderOption[0]) {
            text = `跳蚤(${questions.afterOrderOption[0]})`
          } else {
            text = '跳蚤'
          }

          string.push(text)
        }
        if (item === '璧蝨') {
          let text = ''
          if (questions.afterOrderOption[1]) {
            text = `璧蝨(${questions.afterOrderOption[1]})`
          } else {
            text = '璧蝨'
          }
          string.push(text)
        }
        if (item === '耳炎') {
          let text = ''
          if (questions.afterOrderOption[2]) {
            text = `耳炎(${questions.afterOrderOption[2]})`
          } else {
            text = '耳炎'
          }
          string.push(text)
        }
        if (item === '耳疥') {
          let text = ''
          if (questions.afterOrderOption[3]) {
            text = `耳疥(${questions.afterOrderOption[3]})`
          } else {
            text = '耳疥'
          }
          string.push(text)
        }
        if (item === '眼睛') {
          let text = ''
          if (questions.afterOrderOption[4].length > 0) {
            text = `眼睛(${questions.afterOrderOption[4].join(',')})`
          } else {
            text = '眼睛'
          }
          string.push(text)
        }
      })
      return string.join('，')
    },
    async tryToFetchList() {
      let query = {
        paginate: 0,
        type: 'service'
      }
      if (this.type === 'order') {
        query['orderId'] = this.orderId
      } else if (this.type === 'pet') {
        query['petId'] = this.pet
      }
      try {
        this.tryingFetchList = true
        this.commentList = await this.$store.dispatch('comment/fetchList', query)
      } catch {
      } finally {
        this.tryingFetchList = false
      }
    },

    handleDrawerClosed() {
      this.$refs.drawer.handleClose()
      this.$nextTick(() => {
        this.submitData = cloneDeep(this.defaultValue)
      })

    },
    async handleSave() {
      await this.$refs.form.validate()
      let orderNo = ''
      if (this.order) {
        orderNo = this.orderId
      } else {
        orderNo = this.listOrderId
      }
      try {
        let storeData = {}
        let oldImages = []
        this.fileList.forEach((item) => {
          if (item.url.indexOf('blob') === -1) {
            oldImages.push(item.url)
          }
        })
        if (this.$refs.upload.cacheList.length === 0) {
          if (this.submitData.uuid) {
            // 修改已有的服務紀錄
            storeData = {
              orderNo,
              uuid: this.submitData.uuid,
              images: oldImages,
              questions: this.submitData.questions,
              content: this.submitData.content,
              type: 'service',
              petId: this.order?.pet?.id || this.pet
            }
          } else {
            // 新增服務紀錄
            storeData = {
              orderNo,
              images: oldImages,
              questions: this.submitData.questions,
              content: this.submitData.content,
              type: 'service',
              petId: this.order?.pet?.id || this.pet
            }
          }
        } else {
          const newImages = await this.$refs.upload.handleUpload()
          const filterImages = new Set([...oldImages, ...newImages])
          const images = [...filterImages]
          if (this.submitData.uuid) {
            // 有新增圖片的修改服務紀錄
            storeData = {
              orderNo,
              images,
              questions: this.submitData.questions,
              uuid: this.submitData.uuid,
              content: this.submitData.content,
              type: 'service',
              petId: this.order?.pet?.id || this.pet
            }
          } else {
            // 有新增圖片的新增服務紀錄
            storeData = {
              orderNo,
              images,
              questions: this.submitData.questions,
              content: this.submitData.content,
              type: 'service',
              petId: this.order?.pet?.id || this.pet
            }
          }
        }
        this.tryingSave = true
        await this.$store.dispatch('comment/store', storeData)

        if (this.submitData.uuid) {
          messageStore('edit')
        } else {
          messageStore('add')
        }
        this.drawerVisible = false
        this.tryToFetchList()
        this.$emit('emitFetch')
      } catch (error) {
        console.error(error)
      } finally {
        this.tryingSave = false
      }
    },
    openEdit(type, comment) {
      if (type === 'edit') {
        this.mode = 'edit'
        this.drawerVisible = true
        if (!this.order) {
          this.listOrderId = comment.orderNo
        }
        const value = cloneDeep(comment)
        this.$nextTick(() => {
          // this.$forceUpdate()

          this.submitData.images = value.images
          this.submitData.content = value.content
          this.submitData.uuid = value.id
          if (value.questions) {
            this.submitData.questions = value.questions
          } else {
            this.submitData.questions = {
              afterOrderOption: [null, null, null, null, []],
              afterOrder: [],
              handle: [],
            }
          }
          this.defaultValue = cloneDeep(this.submitData)
          this.tryToGetFileList(this.submitData.images)
        })
        // this.$refs.upload.tryToGetFileList()
      } else {
        this.mode = 'new'
        this.drawerVisible = true
        this.$nextTick(() => {
          // this.$refs.upload.clearFiles()
          this.submitData.uuid = ''
          this.submitData.images = []
          this.submitData.content = ''
          this.submitData.questions = {
            afterOrderOption: [null, null, null, null, []],
            afterOrder: [],
            handle: [],
          }
          this.tryToGetFileList([])
        })
      }
    },
    tryToGetFileList(images) {
      if (images.length === 0) {
        this.fileList = []
      } else {
        this.fileList = images.map((item) => {
          return {
            url: item,
          }
        })
        // this.$nextTick(() => {
        //   this.$refs.upload.checkPlusDisabled()
        // })
      }
    },
    updateFileList(catchItem) {
      this.fileList = [...this.fileList, catchItem]
    },
    async tryToSendComment(id) {
      try {
        await this.$confirm('確定要發送簡訊', '提示', {
          confirmButtonText: '確定',
          showCancelButton: true,
          type: 'warning',
          center: true,
        })
        await this.$store.dispatch('comment/sendComment', { uuid: id })
        this.$message({ message: '發送成功！', type: 'success' })
      } catch {
      } finally {
        this.dialogSendVisible = false
      }
    },
    handlePreview(url) {
      this.dialogImageUrl = url
      this.dialogImgVisible = true
    },
    /**
     * @description 寵物 -> 歷史紀錄 -> 各個服務紀錄列表的分享
     */
    openSendDialog(id) {
      this.dialogSendVisible = true
      this.commentId = id
      this.tryToGetShareLink(id)
    },
    async tryToGetShareLink(id) {
      this.tryToGetLink = true
      this.shareLink = await this.$store.dispatch('comment/getLink', { uuid: id })
      this.tryToGetLink = false
    },
    copyShareLink() {
      const ghostInput = document.createElement('INPUT')
      document.body.appendChild(ghostInput)
      ghostInput.setAttribute('value', this.shareLink)
      ghostInput.select()
      document.execCommand('copy')
      document.body.removeChild(ghostInput)
      this.$message('連結複製成功')
    },
    async onClickRemove(id) {
      this.tryingRemove = true
      try {
        await this.$store.dispatch('comment/removeComment', { ids: [id] })
        this.$message({ message: '備註刪除成功', type: 'success' })
        this.tryToFetchList()
        this.$emit('emitFetch')
      } finally {
        this.tryingRemove = false
      }
    }
  },
}
</script>
<template>
  <div v-loading="tryingFetchList">
    <div v-if="commentList.length !== 0" :class="$style.CommentSection">
      <div :class="$style.comment">
        <div v-for="comment in commentList" :key="comment.id" class="comment__item" :class="classStyle">
          <div class="comment__head">
            <div>
              <h4 class="comment__title">
                {{ comment.creator.name }}
                <span v-if="comment.orderNo" class="text-muted">（訂單編號：{{ comment.orderNo }}）</span>
              </h4>
              <!-- <div v-if="comment.orderNo" class="comment__tip text-muted">訂單編號：{{ comment.orderNo }}</div>
                <div class="comment__tip text-muted">{{ comment.updatedAt | formatDate('dateTime') }}</div> -->
            </div>
          </div>
          <div class="comment__body">
            <div v-if="comment.images.length > 0" class="comment__img">
              <div v-for="img in comment.images" :key="img" class="comment__img__item" style="cursor: pointer"
                @click="handlePreview(img)">
                <img :src="img" alt="" />
              </div>
            </div>
            <el-row type="flex" :gutter="10">
              <el-col :span="20">
                <div class="comment__btn-group">
                  <div v-if="comment.questions">
                    <div v-if="comment.questions.afterOrder.length > 0" style="margin-bottom:9px;line-height:1.5">美容後問題：
                      <span class="text-secondary">{{ afterOrder(comment.questions) }}</span>
                    </div>
                    <div v-if="comment.questions.handle.length > 0" style="margin-bottom:9px;line-height:1.5">善後處理：
                      <span class="text-secondary">{{ comment.questions.handle.join('，') }}</span>
                    </div>
                  </div>
                  <div v-if="comment.content">
                    備註： <div class="text-secondary comment__content d-inline-block" v-text="comment.content"></div>
                  </div>
                </div>
              </el-col>
              <el-col :span="4" class="text-right ml-auto">
                <el-dropdown :hide-on-click="false">
                  <span class="el-dropdown-link p-3" style="cursor: pointer">
                    <BaseIcon name="ellipsis-h" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="hasPermission || userId === comment.creator.id" :disabled="tryingRemove"
                      @click.native="openEdit('edit', comment)">
                      <span>
                        <BaseIcon name="edit" />
                        編輯
                      </span>
                    </el-dropdown-item>
                    <el-dropdown-item :disabled="tryingRemove" @click.native="openSendDialog(comment.id)">
                      <span>
                        <BaseIcon name="share" />
                        分享
                      </span>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="hasPermission || userId === comment.creator.id" :disabled="tryingRemove"
                      @click.native="onClickRemove(comment.id)">
                      <span>
                        <BaseIcon name="trash-alt" />
                        刪除
                      </span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-col>
            </el-row>
          </div>
          <div class="comment__tip text-muted mt-3">{{ comment.updatedAt | formatDate('dateTime') }}</div>
        </div>
      </div>
      <el-dialog :visible.sync="dialogSendVisible" width="600px" title="選擇發送方式" top="0" append-to-body>
        <div :class="$style['share__buttons']" style="cursor: pointer">
          <div :class="$style['share__button']" @click="tryToSendComment(commentId)">
            <el-button type="text" class="isPrimary">
              <i class="fas fa-sms" :class="$style['share__icon']"></i>
            </el-button>
            <div :class="$style['share__label']">簡訊</div>
          </div>
          <div v-loading="tryToGetLink" :class="$style['share__button']" style="cursor: pointer">
            <el-button type="text" class="isPrimary" @click="copyShareLink">
              <i class="fas fa-copy" :class="$style['share__icon']"></i>
            </el-button>
            <div :class="$style['share__label']">複製連結</div>
          </div>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="dialogImgVisible" width="800px" top="0" append-to-body>
        <img width="100%" :src="dialogImageUrl" />
      </el-dialog>
    </div>
    <div v-else>
      <p>還沒有{{ $t('reserve.CLIENT') }}備註</p>
    </div>
    <el-drawer ref="drawer" class="mobile isStylePetCommentList" :visible.sync="drawerVisible"
      :class="{ 'appStyle': appStyle }" append-to-body :size="$root.isSmallDevice ? '100%' : '50%'" destroy-on-close>
      <div slot="title" class="fs-lg">
        <!-- <button class="el-drawer__close-btn isStyleMobileNone" aria-label="close drawer" type="button" @click="handleDrawerClosed"><i class="el-dialog__close el-icon el-icon-close "></i></button>  -->
        <h4 class="ml-3 d-inline">{{ mode === 'new' ? '新增服務紀錄' : '編輯服務紀錄' }}</h4>
      </div>
      <!-- <el-page-header :content="mode === 'new' ? '新增服務紀錄' : '編輯服務紀錄'" class="my-3 MobilepageHeader" @back="handleDrawerClosed"></el-page-header> -->
      <el-divider class="my-md-4 my-3"></el-divider>
      <div :class="$style.CommentSection">
        <el-form ref="form" :model="submitData" :rules="submitRules" label-position="top"
          :validate-on-rule-change="false">
          <el-form-item label="">
            <ImageUpload ref="upload" v-model="submitData.images" :trying-save.sync="tryingSave" :file-list="fileList"
              :class="[$style.upload, $style.isStylePetCommtentList]" :show-upload="true"
              @updateFileList="updateFileList">
            </ImageUpload>
          </el-form-item>
          <el-form-item v-if="$merchantI18n() === 'pet'" :class="$style.afterCosmetic">
            <h4 slot="label" class="form-block-title my-0">美容後問題</h4>
            <el-checkbox-group v-model="submitData.questions.afterOrder">
              <el-checkbox class="sp-ck mr-3" label="正常">正常</el-checkbox>
              <el-checkbox class="sp-ck mr-3" label="皮膚病">皮膚病</el-checkbox>
              <el-checkbox class="sp-ck mr-3" label="指甲流血">指甲流血</el-checkbox>
              <el-checkbox class="sp-ck" label="剃傷">剃傷</el-checkbox>
              <div v-if="dingBeautyNotShow" class="inline-ck">
                <el-checkbox class="sp-ck" label="跳蚤">跳蚤 </el-checkbox>
                <div class="inline-ck-item">
                  <div class="is-show" style="padding-right: 20px">( </div>
                  <el-radio v-model="submitData.questions.afterOrderOption[0]" label="少量">少量</el-radio>
                  <el-radio v-model="submitData.questions.afterOrderOption[0]" label="多量">多量</el-radio>
                  <div class="is-show"> )</div>
                </div>
              </div>
              <div class="inline-ck">
                <el-checkbox class="sp-ck" :label="`${$t('afterServiceQ.Q1')}`">{{ $t('afterServiceQ.Q1') }} </el-checkbox>
                <div class="inline-ck-item">
                  <div class="is-show" style="padding-right: 20px">( </div>
                  <el-radio v-model="submitData.questions.afterOrderOption[1]"
                    :label="`${$t('afterServiceQ.situation1')}`">{{ $t('afterServiceQ.situation1') }}</el-radio>
                  <el-radio v-model="submitData.questions.afterOrderOption[1]"
                    :label="`${$t('afterServiceQ.situation2')}`">{{ $t('afterServiceQ.situation2') }}</el-radio>
                  <div class="is-show"> )</div>
                </div>
              </div>
              <div class="inline-ck">
                <el-checkbox class="sp-ck" :label="`${$t('afterServiceQ.Q2')}`">{{ $t('afterServiceQ.Q2') }}</el-checkbox>

                <div class="inline-ck-item">
                  <div class="is-show" style="padding-right: 20px">( </div>
                  <el-radio v-model="submitData.questions.afterOrderOption[2]" label="輕微">輕微</el-radio>
                  <el-radio v-model="submitData.questions.afterOrderOption[2]" label="嚴重">嚴重</el-radio>
                  <div class="is-show"> )</div>
                </div>
              </div>
              <div class="inline-ck">
                <el-checkbox class="sp-ck" :label="`${$t('afterServiceQ.Q3')}`">{{ $t('afterServiceQ.Q3') }}</el-checkbox>
                <div class="inline-ck-item">
                  <div class="is-show" style="padding-right: 20px">( </div>
                  <el-radio v-model="submitData.questions.afterOrderOption[3]" label="輕微">輕微</el-radio>
                  <el-radio v-model="submitData.questions.afterOrderOption[3]" label="嚴重">嚴重</el-radio>
                  <div class="is-show"> )</div>
                </div>
              </div>
              <div v-if="dingBeautyNotShow" class="inline-ck">
                <el-checkbox class="sp-ck" label="眼睛">眼睛</el-checkbox>

                <el-checkbox-group v-model="submitData.questions.afterOrderOption[4]" class="inline-ck-item">
                  <div class="is-show" style="padding-right: 20px">( </div>
                  <el-checkbox label="紅眼">紅眼</el-checkbox>
                  <el-checkbox label="分泌物">分泌物</el-checkbox>
                  <el-checkbox label="毛渣凝塊">毛渣凝塊</el-checkbox>
                  <el-checkbox label="闔眼">闔眼</el-checkbox>
                  <div class="is-show" style="padding-left: 25px"> )</div>
                </el-checkbox-group>
              </div>
              <!-- <el-checkbox   :label='item'>{{item.title}}</el-checkbox>
                  <el-checkbox-group  :key="index" v-model="afterOrderOption">
                    <el-checkbox   :label='item'>{{item.title}}</el-checkbox>
                  </el-checkbox-group> -->
            </el-checkbox-group>
          </el-form-item>
          <el-form-item v-if="$merchantI18n() === 'pet'">
            <h4 slot="label" class="form-block-title my-0">善後處理</h4>
            <el-checkbox-group v-model="submitData.questions.handle">
              <el-checkbox class="sp-ck mr-3" label="已上藥">已上藥</el-checkbox>
              <el-checkbox class="sp-ck" label="經醫師看診">經醫師看診</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="備註" prop="content">
            <el-input v-model="submitData.content" type="textarea" :autosize="{ minRows: 3 }"
              class="bg-white is-border" />
          </el-form-item>
        </el-form>
        <div class="btn-group-inline">
          <el-button plain class="is-round" @click="handleDrawerClosed">取消</el-button>
          <el-button :loading="tryingSave" :disabled="tryingSave" class="is-round" type="primary"
            @click="handleSave">儲存</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<style lang="scss" module>
:global {
  .el-checkbox-group {
    .is-show {
      font-size: 12px;
    }
  }

  .sp-ck {
    margin-right: 0;
  }

  .inline-ck {
    display: flex;
    justify-content: flex-start;

    .sp-ck {
      width: auto;
    }

    // justify-content: space-between;
  }

  .inline-ck-item {
    display: flex;
    align-items: center;
    margin-left: 25px;
    width: 100%;
    flex-wrap: wrap;
  }
}

@import '@design';

.CommentSection {
  padding: 0 20px 20px;

  // background-color: #fff;
  // background: $color-line;
  @include max-sm {
    padding: 0;
  }
}

.comment {
  padding-top: 20px;

  :global {
    .comment {
      &__item {
        @include touch {
          padding: 0 15px;
        }

        &+.comment__item {
          padding-top: 20px;
          margin-top: 20px;
          border-top: $color-border-base 1px dashed;
        }

        &:last-child {
          padding-bottom: 20px;
        }

        &.isStyleBgWhite {
          .comment__body {
            background: $color-line;
          }
        }
      }

      &__img {
        margin-bottom: 20px;
        display: flex;
        flex-wrap: wrap;
        margin-left: -0.3rem;
        margin-right: -0.3rem;

        &__item {
          // width: 100%;
          width: 16.5%;
          padding-bottom: 16.5%;
          position: relative;
          margin-left: 0.3rem;
          margin-right: 0.3rem;
          margin-bottom: 0.5rem;
          // @include touch {
          //   height: 13.6vw;
          // }
        }

        // padding-bottom: 10px;
        img {
          width: 100%;
          height: 100%;
          position: absolute;
          object-fit: cover;
          object-position: center;
        }
      }

      &__content {
        white-space: pre;
      }

      &__head {
        display: flex;
        justify-content: space-between;
        // align-items: center;
        margin-bottom: 10px;
      }

      &__title {
        margin: 0;
        margin-bottom: 10px;
        font-size: 14px;
      }

      &__tip {
        margin-bottom: 4px;
      }

      &__btn-group {
        min-width: 80px;
        overflow: auto;
      }

      &__body {
        background: #fff;
        border-radius: 0 20px 20px 20px;
        padding: 1.25rem;
      }
    }
  }
}

.isStylePetCommtentList {
  .el-upload {
    transform: scale(0.8);
  }
}

.share {
  &__buttons {
    display: flex;
    padding: 30px 0;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  &__button {
    width: 30%;
    // flxex: 1;
  }

  &__icon {
    font-size: 3rem;
  }

  &__label {
    margin-top: 10px;
  }
}

.afterCosmetic {
  overflow-x: scroll;

  :global {
    .el-form-item__content {
      width: 575px;
      max-width: 100%;
    }
  }
}

// %img-size {
//   width: calc(33.333333% - 10px);
//   height: 175px;
//   @include max-sm {
//     width: calc(100% - 10px);
//   }
// }
// :global {
//   :local(.upload) {
//     margin: 0 -10px;
//     border-top: none !important;
//     > div {
//       @extend %img-size;
//     }

//     .image-and-action {
//       @extend %img-size;
//       & + div {
//         @extend %img-size;
//       }
//     }
//   }
// }</style>